import script from "./StakingInterestSchedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingInterestSchedule.vue?vue&type=script&setup=true&lang=ts"

import "./StakingInterestSchedule.vue?vue&type=style&index=0&id=27a53548&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a53548"]])

export default __exports__